import {removeTable_v2,generateTableUpdated_v2} from './initialize-sdt';

export const initializeDensityButtons_v2 = function(page_id,tableHeads,data){

	var smBtn = document.getElementById('sh-dens-sm');
	if(smBtn != null){
		smBtn.id = "sh-dens-sm#" + page_id;
	}
	else{
		smBtn = document.getElementById("sh-dens-sm#" + page_id);
	}

	var mdBtn = document.getElementById('sh-dens-md');
	if(mdBtn != null){
		mdBtn.id = "sh-dens-md#" + page_id;
	}
	else{
		mdBtn = document.getElementById("sh-dens-md#" + page_id);
	}

	var lgBtn = document.getElementById('sh-dens-lg');
	if(lgBtn != null){
		lgBtn.id = "sh-dens-lg#" + page_id;
	}
	else{
		lgBtn = document.getElementById('sh-dens-lg#'+ page_id)
	}
	smBtn.onclick = function (){
		removeTable_v2(page_id);

		generateTableUpdated_v2(window.hoverButtons_v2,window.selectType_v2,window.selectionColumn_v2,page_id,tableHeads, data,"sm",window.globalHeight_v2,window.globalSortField_v2,window.globalSortDirection_v2,window.globalViews_v2,window.globalCurrentView_v2);
	};

	mdBtn.onclick = function (){

		removeTable_v2(page_id);
		generateTableUpdated_v2(window.hoverButtons_v2,window.selectType_v2,window.selectionColumn_v2,page_id,tableHeads, data,"md",window.globalHeight_v2,window.globalSortField_v2,window.globalSortDirection_v2,window.globalViews_v2,window.globalCurrentView_v2);
	};

	lgBtn.onclick = function (){

		removeTable_v2(page_id);
		generateTableUpdated_v2(window.hoverButtons_v2,window.selectType_v2,window.selectionColumn_v2,page_id,tableHeads, data,"lg",window.globalHeight_v2,window.globalSortField_v2,window.globalSortDirection_v2,window.globalViews_v2,window.globalCurrentView_v2);
	};
}